import { render, staticRenderFns } from "./uiDropdown.vue?vue&type=template&id=68a541dc&scoped=true"
import script from "./uiDropdown.vue?vue&type=script&lang=js"
export * from "./uiDropdown.vue?vue&type=script&lang=js"
import style0 from "./uiDropdown.vue?vue&type=style&index=0&id=68a541dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a541dc",
  null
  
)

export default component.exports